function getParamUrl() {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let token = params.get("token");
  return token;
}

export const getParamUrlByKey=(keyparame)=>{
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let res;

  if (keyparame) {
    res = params.get(keyparame);
  }
  return res;
}

export const formatMoney = (money) => {
  const res = `${money || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return res;
};

export const formatMoneyToNumber = (str) => {
  if (!str) return;
  const res = Number((str || "0").replace(/[.,]/g, ""));
  return res;
};

export const isEmailValid = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

function _validPhone(phone1) {
  // carrier 1 là vietel, 2 là mobi, 3 là vina
  var phone = phone1.substr(0, 3);
  var viettel = /((086|096|097|098|032|033|034|035|036|037|038|039))/g;
  var mobi = /((089|090|093|070|071|072|076|077|078|079))/g;
  var vina = /((088|091|094|083|084|085|081|082))/g;
  var vietnamobile = /((092|056|058))/g;
  var gmobile = /((099|059))/g;
  var sFone = /((095))/g;

  if (phone.toString().length !== 10) return "Số điện thoại phải đủ 10 số";

  if (
    viettel.test(phone) ||
    mobi.test(phone) ||
    vina.test(phone) ||
    vietnamobile.test(phone) ||
    gmobile.test(phone) ||
    sFone.test(phone)
  ) {
    return "";
  } else {
    return "Số điện thoại không đúng";
  }
}


function _getTPlatformParamUrl() {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let platform = params.get("platform");
  return platform;
}


function capitalize(str) {
  if (!str) {
    return "";
  }
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

function formatNumber2(num) {
  if (Math.abs(num) >= 1.0e+9) {
    return (Math.abs(num) / 1.0e+9).toFixed(1) + "B";
  } else if (Math.abs(num) >= 1.0e+6) {
    return (Math.abs(num) / 1.0e+6).toFixed(1) + "M";
  } else if (Math.abs(num) >= 1.0e+3) {
    return (Math.abs(num) / 1.0e+3).toFixed(1) + "K";
  } else {
    return num;
  }
};

const variable = {
  getParamUrl,
  getParamUrlByKey,
  _getTPlatformParamUrl,
  isEmailValid,
  _validPhone,
  capitalize,
  formatMoney,
  formatNumber2
};
export default variable;
